module.exports = __webpack_public_path__ + "media/introduction/AI_Icon-453b533b.svg";